import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters';
import * as types from './mutation-types';

Vue.use(Vuex)

const state = {
    // cookies: {}
    startPrice: 0
}

const actions = {
    changeStartPrice ({ commit }, { startPrice }) {
        commit(types.CHANGE_BOOK_START_PRICE, startPrice)
    }
}
// mutations
const mutations = {
    [types.CHANGE_BOOK_START_PRICE](state, startPrice) {
        state.startPrice = startPrice;
    }
}

const store = new Vuex.Store({
    modules: {
    },
    strict: process.env.NODE_ENV !== 'production',
    getters,
    actions,
    mutations,
    state
})

export default store



// WEBPACK FOOTER //
// libs/store/index.js